module.exports = __webpack_public_path__ + "static/img/logo.0aa9679a.png";